import { render, staticRenderFns } from "./SessionsView.vue?vue&type=template&id=48707271&"
import script from "./SessionsView.vue?vue&type=script&lang=js&"
export * from "./SessionsView.vue?vue&type=script&lang=js&"
import style0 from "./SessionsView.vue?vue&type=style&index=0&id=48707271&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports